import React, { useEffect } from "react";
import { useNetwork } from "../../hooks/useNetwork";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { IntegrationTableBodyRow } from "./IntegrationTableBodyRow";
import { useIntegrationContext } from "./IntegrationProvider";
import { usePageTablePaginationContext } from "../PageTablePagination/context";
import { usePaginationHandler } from "../../hooks/usePaginationHandler";
// import { formControlClasses } from "@mui/material";


interface IProps {
  showAll?: boolean;
}


export const IntegrationTableBody: React.FC<IProps> = (props) => {
  const { loadIntegrations, integrations } = useIntegrationContext();
  const [ filteredIntegrations, setFilteredIntegrations ] = React.useState(integrations);
  const [isLoading, setIsLoading] = React.useState(false);
  const { getL2 } = useNetwork();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { page, setPage, perPage, setPages } = usePageTablePaginationContext();
  const { selectedRows, pages } = usePaginationHandler(
    filteredIntegrations,
    page,
    perPage
  );

  const showRow = (l1Id: number, l2Id: number) => {
    if(props.showAll) {
      return true;
    }
    return getL2(l1Id, l2Id)?.matchingRoundStatus === "MATCHING" || getL2(l1Id, l2Id)?.matchingRoundStatus === "UPCOMING";
  };

  useEffect(() => {
    const newIntegrations = integrations.filter(i => i && showRow(i.l1Id, i.l2Id));
    setFilteredIntegrations(newIntegrations);
  }, [props.showAll, integrations]);


  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      setPage(1);
      await loadIntegrations(selectedNetworkId);
      setIsLoading(false);
    };

    getData();
  }, [selectedNetworkId]);

  useEffect(() => {
    setPages(pages);
  }, [pages.length]);

  return (
    <EnhancedTableBody colSpan={8} isLoading={isLoading}>
      {selectedRows.map((row) => (
        <IntegrationTableBodyRow {...row} showAll={props.showAll} key={row.id} />
      ))}
    </EnhancedTableBody>
  );
};
